/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetWeaknessViewResponse,
  WeaknessBlastRadiusResponse,
} from '../models/index';
import {
    AssetWeaknessViewResponseFromJSON,
    AssetWeaknessViewResponseToJSON,
    WeaknessBlastRadiusResponseFromJSON,
    WeaknessBlastRadiusResponseToJSON,
} from '../models/index';

export interface MdmAssetWeaknessViewRequest {
    assetGoldenId: string;
    sessionId: string;
    assetClass?: string;
}

export interface MdmWeaknessBlastRadiusRequest {
    weaknessGoldenId: string;
    sessionId: string;
    includePersonTraversal?: boolean;
    personWindowDays?: number;
    personMaxNodes?: number;
}

/**
 * MDMWeaknessBlastRadiusApi - interface
 * 
 * @export
 * @interface MDMWeaknessBlastRadiusApiInterface
 */
export interface MDMWeaknessBlastRadiusApiInterface {
    /**
     * 
     * @summary Asset weakness view (REQ-WR-02, REQ-WR-06)
     * @param {string} assetGoldenId 
     * @param {string} sessionId 
     * @param {string} [assetClass] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMWeaknessBlastRadiusApiInterface
     */
    mdmAssetWeaknessViewRaw(requestParameters: MdmAssetWeaknessViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetWeaknessViewResponse>>;

    /**
     * Asset weakness view (REQ-WR-02, REQ-WR-06)
     */
    mdmAssetWeaknessView(requestParameters: MdmAssetWeaknessViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetWeaknessViewResponse>;

    /**
     * 
     * @summary Weakness blast-radius (REQ-WR-01)
     * @param {string} weaknessGoldenId 
     * @param {string} sessionId 
     * @param {boolean} [includePersonTraversal] 
     * @param {number} [personWindowDays] 
     * @param {number} [personMaxNodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMWeaknessBlastRadiusApiInterface
     */
    mdmWeaknessBlastRadiusRaw(requestParameters: MdmWeaknessBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessBlastRadiusResponse>>;

    /**
     * Weakness blast-radius (REQ-WR-01)
     */
    mdmWeaknessBlastRadius(requestParameters: MdmWeaknessBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessBlastRadiusResponse>;

}

/**
 * 
 */
export class MDMWeaknessBlastRadiusApi extends runtime.BaseAPI implements MDMWeaknessBlastRadiusApiInterface {

    /**
     * Asset weakness view (REQ-WR-02, REQ-WR-06)
     */
    async mdmAssetWeaknessViewRaw(requestParameters: MdmAssetWeaknessViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetWeaknessViewResponse>> {
        if (requestParameters['assetGoldenId'] == null) {
            throw new runtime.RequiredError(
                'assetGoldenId',
                'Required parameter "assetGoldenId" was null or undefined when calling mdmAssetWeaknessView().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mdmAssetWeaknessView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['assetClass'] != null) {
            queryParameters['assetClass'] = requestParameters['assetClass'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/assets/{assetGoldenId}/weaknesses`;
        urlPath = urlPath.replace(`{${"assetGoldenId"}}`, encodeURIComponent(String(requestParameters['assetGoldenId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetWeaknessViewResponseFromJSON(jsonValue));
    }

    /**
     * Asset weakness view (REQ-WR-02, REQ-WR-06)
     */
    async mdmAssetWeaknessView(requestParameters: MdmAssetWeaknessViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetWeaknessViewResponse> {
        const response = await this.mdmAssetWeaknessViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Weakness blast-radius (REQ-WR-01)
     */
    async mdmWeaknessBlastRadiusRaw(requestParameters: MdmWeaknessBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessBlastRadiusResponse>> {
        if (requestParameters['weaknessGoldenId'] == null) {
            throw new runtime.RequiredError(
                'weaknessGoldenId',
                'Required parameter "weaknessGoldenId" was null or undefined when calling mdmWeaknessBlastRadius().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mdmWeaknessBlastRadius().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['includePersonTraversal'] != null) {
            queryParameters['includePersonTraversal'] = requestParameters['includePersonTraversal'];
        }

        if (requestParameters['personWindowDays'] != null) {
            queryParameters['personWindowDays'] = requestParameters['personWindowDays'];
        }

        if (requestParameters['personMaxNodes'] != null) {
            queryParameters['personMaxNodes'] = requestParameters['personMaxNodes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/weaknesses/{weaknessGoldenId}/blast-radius`;
        urlPath = urlPath.replace(`{${"weaknessGoldenId"}}`, encodeURIComponent(String(requestParameters['weaknessGoldenId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WeaknessBlastRadiusResponseFromJSON(jsonValue));
    }

    /**
     * Weakness blast-radius (REQ-WR-01)
     */
    async mdmWeaknessBlastRadius(requestParameters: MdmWeaknessBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessBlastRadiusResponse> {
        const response = await this.mdmWeaknessBlastRadiusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
